import {z} from '@hono/zod-openapi';

export const vehicleMappingCoverageActivationResponseSchema = z
  .object({
    configurationBundleId: z.string().uuid(),
    coverageRunId: z.string().uuid(),
    activatedAt: z.string().datetime(),
  })
  .openapi('VehicleMappingCoverageActivationResponse');

export type VehicleMappingCoverageActivationResponse = z.infer<
  typeof vehicleMappingCoverageActivationResponseSchema
>;
